import classNames from 'classnames';

import { buttonElement } from './ButtonElement.css';
import type { ButtonElementProps } from './ButtonElement.types';

export function ButtonElement({
  children,
  type = 'button',
  disabled = false,
  isSubmitting = false,
  onClick,
  variant = 'default',
  className,
}: ButtonElementProps) {
  return (
    <button
      type={type}
      disabled={disabled || isSubmitting}
      className={classNames(
        buttonElement[variant],
        'rounded-md text-sm py-2 px-3 leading-5 font-medium',
        variant !== 'flush' && 'shadow-sm',
        className,
      )}
      onClick={onClick}
    >
      {isSubmitting ? (
        <span className="flex items-center gap-1.5">
          <svg
            className="animate-spin h-3.5 w-3.5"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            aria-hidden="true"
          >
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
          </svg>
          {children}
        </span>
      ) : (
        children
      )}
    </button>
  );
}
